// src/index.js
/**
 * Application entry point.
 *
 * Responsibilities:
 * 1. Bootstrap React into the DOM.
 * 2. Wrap the app with global providers (Router, AuthContext, etc.).
 * 3. Enable performance reporting via `reportWebVitals`.
 */

import "./i18n"; // ← runs the init() side-effect
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router } from "react-router-dom";

/**
 * Groups top-level context providers in one place.
 * Add new providers here to keep index.js uncluttered.
 */
const Providers = ({ children }) => (
  <AuthProvider>
    <Router>{children}</Router>
  </AuthProvider>
);

/**
 * Mount the React tree.
 */
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);

reportWebVitals();
